export default __webpack_public_path__ + "static/media/Template_1_dark.f9d22c01.svg";